import { Link2 } from "lucide-react";

import { BulkChangeStatusDropdown } from "@/features/requests/components/BulkChangeStatusDropdown";

interface ProjectRequestsBulkActionsProps {
  isLoading: boolean;
  onCopyLinks: () => void;
  onStatusSelect: (statusId: number, statusLabel: string) => void;
  selectedCount: number;
}

export function ProjectRequestsBulkActions({
  isLoading,
  onCopyLinks,
  onStatusSelect,
  selectedCount,
}: ProjectRequestsBulkActionsProps) {
  const isDisabled = selectedCount === 0 || isLoading;

  return (
    <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
      <h3 className="text-xl font-semibold text-text-primary ml-3">Requests</h3>

      <div className="flex items-center gap-2">
        <button
          className="flex items-center gap-2 whitespace-nowrap bg-button-secondary-bg px-3 py-1.5 text-sm rounded-md border shadow-sm transition-colors border-border-primary text-button-secondary-fg hover:bg-button-secondary-bg-hover disabled:border-border-secondary disabled:text-fg-disabled disabled:cursor-not-allowed disabled:hover:bg-button-secondary-bg"
          disabled={isDisabled}
          onClick={onCopyLinks}
          type="button"
        >
          <Link2 className="shrink-0" height={16} strokeWidth={2} width={16} />
          <span className="font-semibold">Copy link</span>
        </button>
        <BulkChangeStatusDropdown
          isDisabled={isDisabled}
          isLoading={isLoading}
          onStatusSelect={onStatusSelect}
        />
      </div>
    </div>
  );
}
